// import $ from "jquery";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { decrypt } from "../../utils/encodingdecoding";
import { novus_logo } from "../../Image/Index";
import { getDate } from "../../utils/helper";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Token_Generator } from "../../actions/auth";
// import { notifications, profilePic, settings, settingsHover, helpFAQs, helpFAQsHover, logoutIcon, logoutIconHover } from "../../Image/Index";
const AdminHeader = (props) => {
    const [name, setName] = useState();
    const [data, setData] = useState();
    const [datas, setDatas] = useState();

    useEffect(() => {
        if (localStorage.getItem("name")) {
            let tempName = localStorage.getItem("name");
            tempName = `${tempName[0].toUpperCase()}${tempName.slice(1)}`;
            setName(tempName);
        }
    }, []);

  
    const firstName = localStorage.getItem("name")
    const lastName = localStorage.getItem("lastName")
  
    const handleLogout = () => {
        localStorage.clear();
        sessionStorage.clear()
    };
    const names = props.name || "";
    return (
        <div className="dashboard__headerSection">
           

            <div className="dashboard__heading">
                <h3>{props.name}</h3>
            </div>
            {name && (
               
              
                <div>
                          <h5>
                        Welcome : {""}
                        <Link to="/dashboard">
                            <span>{firstName}</span>
                        </Link>
                    </h5>
                   
                </div>
              
                
            )}
           
            <ToastContainer autoClose={false} />
        </div>
    );
};

export default AdminHeader;
